import { DEFAULT_LOCATION, ITenantConfig } from '@northladder/services';

import {
  ITenantDetailsResponseDataRaw,
  ITenantEnvironmentConfigResponse,
  ITenantEnvironmentOverrides,
} from './types';

/**
 * This formats the tenant config response to suit the app's needs.
 * Please merge this with `formatTenantDetailsResponse` and switch the api an cdn urls
 * TODO: really format this. Revise this with
 * TODO: Revise this with `formatTenantEnvDetails`
 */
export function formatB2BTenantConfigResponse(
  responseData: ITenantDetailsResponseDataRaw,
  identifier: string,
  logoUrl?: string
): ITenantConfig {
  const { tenantId, defaultCurrency: currency, configuration } = responseData;
  const label = responseData?.label;
  const basePath = responseData?.configuration?.common?.basePath || {};

  const apiBaseURL = basePath.partnerService;
  const cdnBaseUrl = `${basePath.partnerCdn}/`;

  const { phoneNumberPrefixes } = configuration?.common || {};
  const {
    buyerAppUrl,
    contactInformation,
    termsAndConditions,
    workingHours,
    emailOTPForOnboarding,
  } = configuration?.apps?.dealer || {};
  const buyerConfig = configuration?.apps?.buyer || {};
  const commonAppConfig = configuration?.apps?.common || {};

  const {
    contactNumber = '',
    whatsappNumber = '',
    address = '',
    email = '',
    coordinates = DEFAULT_LOCATION,
  } = contactInformation || {};

  return {
    address,
    apiBaseURL,
    buyerAppUrl: buyerAppUrl || '',
    buyerConfig,
    cdnBaseUrl,
    coordinates,
    commonAppConfig,
    contactNumber,
    countryCode: phoneNumberPrefixes[0] || '',
    currency,
    email,
    emailOTPForOnboarding,
    identifier,
    label,
    logoUrl: logoUrl || '',
    tenantId,
    termsAndConditions,
    whatsappNumber,
    workingHours,
  };
}

export interface IFormattedTenantListPayload {
  /**
   * @deprecated - We dont need the components to care about this key.
   */
  appName?: keyof ITenantEnvironmentOverrides;
  tenantConfig: ITenantEnvironmentConfigResponse;
}

export function formatTenantList({
  appName,
  tenantConfig,
}: IFormattedTenantListPayload): ITenantEnvironmentConfigResponse {
  const { environments, languages, overrides } = tenantConfig;

  // TODO: Refactor this later so we don'g need to pass the `appName` here.
  const allowedEnvironmentIds = appName && overrides?.[appName]?.environments;

  const formattedEnvironments = environments
    .filter((env) => {
      if (!allowedEnvironmentIds) {
        return true;
      }
      return allowedEnvironmentIds.includes(env.identifier);
    })
    .map(({ identifier, label, logoUrl }) => ({
      id: identifier || 'global',
      identifier,
      label,
      logoUrl,
    }));

  return {
    environments: formattedEnvironments,
    languages,
    overrides,
  };
}

/**
 * This formats the tenant config response to suit the app's needs.
 * Please merge this with `formatB2BTenantConfigResponse` and switch the api an cdn urls
 */
export function formatTenantDetailsResponse(
  responseData: ITenantDetailsResponseDataRaw,
  identifier: string,
  logoUrl?: string
): ITenantConfig {
  const { tenantId, defaultCurrency: currency, configuration } = responseData;
  const label = responseData?.label;
  const basePath = responseData?.configuration?.common?.basePath || {};

  const apiBaseURL = basePath.genericService;
  const cdnBaseUrl = `${basePath.genericCdn}/`;

  const { phoneNumberPrefixes } = configuration?.common || {};
  const {
    buyerAppUrl,
    contactInformation,
    termsAndConditions,
    workingHours,
    emailOTPForOnboarding,
  } = configuration?.apps?.dealer || {};
  const buyerConfig = configuration?.apps?.buyer || {};
  const commonAppConfig = configuration?.apps?.common || {};

  const {
    contactNumber = '',
    whatsappNumber = '',
    address = '',
    email = '',
    coordinates = DEFAULT_LOCATION,
  } = contactInformation || {};

  return {
    address,
    apiBaseURL,
    buyerAppUrl,
    buyerConfig,
    cdnBaseUrl,
    commonAppConfig,
    contactNumber,
    coordinates,
    countryCode: phoneNumberPrefixes[0] || '',
    currency,
    email,
    emailOTPForOnboarding,
    identifier,
    label,
    logoUrl: logoUrl || '',
    tenantId,
    termsAndConditions,
    whatsappNumber,
    workingHours,
  };
}
